/**
 * Keeps ?model=men|women on links to products that use model galleries.
 *
 * - Product cards whose gallery has data-mg-card-model (snippets/card-gallery.liquid) link to that model.
 *   Cards whose model came from the shop default (not the collection) follow the model currently shown
 *   on a product page instead, e.g. "You may also like" under the women's gallery links to ?model=women.
 * - On a product page, links to the colour-sibling products listed in window.BWModelGallery.linkHandles
 *   keep the current model, so changing colour keeps the gallery.
 *
 * Links are rewritten on load and again right before they are used, because the theme resets card
 * hrefs after a swatch selection (product-card.js #updateProductUrl).
 */
(function () {
  function pageModel() {
    return (window.BWModelGallery && window.BWModelGallery.model) || null;
  }

  function productHandle(url) {
    var match = url.pathname.match(/\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  // The marker sits on the card's gallery; the card's links (image, title, card overlay) are all inside <product-card>.
  function cardMarker(element) {
    var card = element.closest('product-card');
    return card && card.querySelector('[data-mg-card-model]');
  }

  function modelFor(anchor, url) {
    var card = cardMarker(anchor);
    if (card) {
      var fromCollection = card.getAttribute('data-mg-card-source') === 'collection';
      return (!fromCollection && pageModel()) || card.getAttribute('data-mg-card-model');
    }

    var handles = window.BWModelGallery && window.BWModelGallery.linkHandles;
    if (handles && pageModel() && handles.indexOf(productHandle(url)) > -1) return pageModel();

    return null;
  }

  function apply(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || !anchor.getAttribute('href')) return;

    var url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || !productHandle(url)) return;

    var model = modelFor(anchor, url);
    if (!model || url.searchParams.get('model') === model) return;

    url.searchParams.set('model', model);
    anchor.href = url.toString();
  }

  function sweep() {
    document.querySelectorAll('a[href*="/products/"]').forEach(apply);
  }

  function onInteraction(event) {
    if (!(event.target instanceof Element)) return;

    // Cards also navigate from clicks outside their anchors (product-card.js navigateToProduct).
    var card = cardMarker(event.target) && event.target.closest('product-card');
    if (card) card.querySelectorAll('a[href]').forEach(apply);

    apply(event.target.closest('a'));
  }

  ['pointerover', 'focusin', 'pointerdown', 'click'].forEach(function (type) {
    document.addEventListener(type, onInteraction, true);
  });

  document.addEventListener('bw:model-change', sweep);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
})();
